var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkmode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5C9 6.82806 9.09101 6.17735 9.25684 5.55762C6.75419 6.6246 5 9.10756 5 12C5 15.866 8.13401 19 12 19V21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C12.4138 3 12.8208 3.02992 13.2197 3.08398C11.8724 4.08644 11 5.69157 11 7.5C11 10.5376 13.4624 13 16.5 13C18.3085 13 19.9126 12.1267 20.915 10.7793C20.9692 11.1786 21 11.5858 21 12C21 16.9706 16.9706 21 12 21V19C14.8926 19 17.3745 17.2451 18.4414 14.7422C17.822 14.908 17.1718 15 16.5 15C12.3579 15 9 11.6421 9 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmode);
export default __webpack_public_path__ + "static/media/Dark mode.3ac099fb9b08095c7f7a5cb78d39b904.svg";
export { ForwardRef as ReactComponent };